import mapDateRangeValues from "./map-date-range-values";
import mapWidgetLayoutValues from "./map-widget-layout-values";

export default function (
  values: any,
  method: string,
  originalValues: any = {}
): any {
  const result: any = {};
  result.id = values ? values.id : undefined;
  result.title = values ? values.title : undefined;
  result.type = values ? values.type : undefined;
  result.interval = mapDateRangeValues(values.interval, method);
  result.panelId = values ? values.panelId : undefined;
  result.layout = mapWidgetLayoutValues(values.layout, method);
  return result;
}
